<template>
    <div>
        <el-table :data="compare" key="update" border style="width:97%">
            <el-table-column :label="title" prop="name"></el-table-column>
            <el-table-column label="内容" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "delete_pay",
        props: {
            order_edit: {
                required: true
            }
        },
        data() {
            return {
                title:'',
                compare: []
            }
        },
        created() {
            this.title = '删除项(回款ID:'+this.order_edit.content.id+')';
            this.setTitle();
        },
        methods:{
            setTitle(){
                let play_pay={
                    name: '计划回款金额',
                    after: this.order_edit.content.plan_amount
                };
                let play_at={
                    name: '计划回款日期',
                    after: this.order_edit.content.plan_at,
                };

                let  actual_pay= {
                    name: '实际回款金额',
                    after:this.order_edit.content.actual_amount,
                };
                let  actual_at= {
                    name: '实际回款日期',
                    after: this.order_edit.content.actual_at,
                };
                this.compare.push(play_pay);
                this.compare.push(play_at);
                this.compare.push(actual_pay);
                this.compare.push(actual_at);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/delete_pay.vue